// Generated from src/assets/Check.svg
import React, { PureComponent } from "react";

interface ISVGZoomIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  cursor: "pointer",
  display: "block"
};

export default class SVGZoomIcon extends PureComponent<ISVGZoomIconProps, {}> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 32}
        fill={fill || "currentColor"}
        style={style}
        x="0px"
        y="0px"
        width="35px"
        height="34px"
        viewBox="288.5 378.5 35 35"
        enableBackground="new 288.5 378.5 35 35"
      >
        <path
          d="M296.24,384.207c0,0.176,0.249,0.441,0.249,0.618c-2.97,1.896-4.262,7.489-1.854,11.034
	c0.824,1.212,1.507,1.701,2.647,2.912c0.085,0.644-0.23,0.478-0.511,0.361c-0.178,0-1.205-0.583-1.873-1.155
	c-2.312-1.984-3.521-7.228-1.854-10.856c0.417-0.91,1.256-1.604,1.927-2.35C295.138,384.586,295.837,384.061,296.24,384.207z"
        />
        <path
          d="M301.247,378.641c-6.979,0-12.639,5.657-12.639,12.638s5.659,12.639,12.639,12.639
	s12.639-5.658,12.639-12.639S308.227,378.641,301.247,378.641z M301.247,402.177c-6.02,0-10.899-4.879-10.899-10.898
	s4.88-10.899,10.899-10.899c6.019,0,10.898,4.88,10.898,10.899S307.266,402.177,301.247,402.177z"
        />
        <path
          d="M323.25,409.27c-1.204-1.234-5.295-5.968-7.971-8.055l-1.184-1.163c-0.313-0.307-0.917-0.201-1.347,0.236
	l-2.602,2.646c-0.431,0.438-0.526,1.042-0.214,1.35l2.278,2.24c0.05,0.05,0.11,0.085,0.174,0.113c1.65,2.063,4.953,5.78,6.876,6.431
	c0.789,0.557,2.349,0.22,2.913-0.264C323.463,411.925,323.545,410.101,323.25,409.27z"
        />
      </svg>
    );
  }
}
